import React from "react";
import { Play, Pause, RotateCcw, RotateCw, Maximize, Minimize } from "lucide-react";
import type { VideoSpeed } from "../../types/video";
import { ProgressBar } from "./ProgressBar";
import { SpeedMenu } from "./SpeedMenu";
import { VolumeControl } from "./VolumeControl";

interface VideoControlsProps {
  isVisible: boolean;
  isPlaying: boolean;
  currentTime: number;
  duration: number;
  volume: number;
  speed: VideoSpeed;
  isFullscreen: boolean;
  onPlayPause: () => void;
  onSeek: (time: number) => void;
  onVolumeChange: (volume: number) => void;
  onSpeedChange: (speed: VideoSpeed) => void;
  onToggleFullscreen: () => void;
  onSeekBackward: () => void;
  onSeekForward: () => void;
}

export function VideoControls({
  isVisible,
  isPlaying,
  currentTime,
  duration,
  volume,
  speed,
  isFullscreen,
  onPlayPause,
  onSeek,
  onVolumeChange,
  onSpeedChange,
  onToggleFullscreen,
  onSeekBackward,
  onSeekForward,
}: VideoControlsProps) {
  return (
    <div
      className={`absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-4 transition-opacity duration-300 ${
        isVisible ? "opacity-100" : "opacity-0"
      }`}>
      <ProgressBar currentTime={currentTime} duration={duration} onSeek={onSeek} />

      <div className="flex items-center justify-between mt-2">
        <div className="flex items-center gap-2">
          <button onClick={onPlayPause} className="p-2 hover:bg-white/20 rounded-full transition-colors">
            {isPlaying ? <Pause className="w-6 h-6 text-white" /> : <Play className="w-6 h-6 text-white" />}
          </button>

          <button onClick={onSeekBackward} className="p-2 hover:bg-white/20 rounded-full transition-colors" title="10 Saniye Geri">
            <RotateCcw className="w-5 h-5 text-white" />
          </button>

          <button onClick={onSeekForward} className="p-2 hover:bg-white/20 rounded-full transition-colors" title="10 Saniye İleri">
            <RotateCw className="w-5 h-5 text-white" />
          </button>

          <VolumeControl volume={volume} onVolumeChange={onVolumeChange} />
        </div>

        <div className="flex items-center gap-2">
          <SpeedMenu currentSpeed={speed} onSpeedChange={onSpeedChange} />

          <button onClick={onToggleFullscreen} className="p-2 hover:bg-white/20 rounded-full transition-colors">
            {isFullscreen ? <Minimize className="w-5 h-5 text-white" /> : <Maximize className="w-5 h-5 text-white" />}
          </button>
        </div>
      </div>
    </div>
  );
}
